function o(r, t = []) {
  return t.filter(
    (e) => e.orderFormat === r
  )[0];
}
export {
  o as default
};
